import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const WarehouseOutputSchema = z.object({
  _id: z.string(),
  name: z.string(),
  address: z.string(),
  team: z.string(),
});

export const getWarehouses = unaryRpc({
  name: "getWarehouses" as const,
  input: z.null(),
  output: z.object({ warehouses: z.array(WarehouseOutputSchema) }),
});
